import Image from '@react/shared/components/Image';
import { assetPath } from 'sly/lib/path';
import { createApiClient, usePrefetch } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';
import {
  SitemapLayout,
  SitemapLink,
  SitemapLinkWrapper,
} from 'sly/sitemap/components/SitemapSharedComponents';
import { sitemapProvidersBreadCrumbItems } from 'sly/sitemap/constants';
import { Heading } from 'sly/system';

const StateSitemap = () => {
  const {
    requestInfo: { normalized: agents, hasFinished },
  } = usePrefetch('getSitemapAgents');

  if (!hasFinished) {
    return (
      <div className='flex h-screen items-center justify-center'>
        <Image
          width='1'
          height='1'
          alt=''
          src={assetPath('uploads/react-assets/homebase/loader.svg')}
        />
      </div>
    );
  }

  const filteredAgents = agents.filter(
    (agent) => !agent.name?.includes('CarePatrol')
  );

  return (
    <SitemapLayout
      headTitle='All State Pages Site Map | Seniorly'
      breadcrumbItems={sitemapProvidersBreadCrumbItems}
      metaDescription='Sitemap of all provider pages on Seniorly. Find the provider you are looking for.'
    >
      <Heading as='h2' className='mb-6'>
        Agent Pages
      </Heading>

      <SitemapLinkWrapper>
        {filteredAgents
          .sort(({ name: a }, { name: b }) => a.localeCompare(b))
          .map(({ name, url, id, isPremier }) => {
            return (
              <SitemapLink
                className='mb-2 block md:w-[calc((100%-1.5rem)/2)]'
                href={isPremier ? `/premier-advisor/${id}` : url}
                key={name}
              >
                {name}
              </SitemapLink>
            );
          })}
      </SitemapLinkWrapper>
    </SitemapLayout>
  );
};

export const getServerSideProps = async () => {
  const { api, store } = createApiClient(apiEndpoints);

  await store.dispatch(api.getSitemapAgents.asAction());

  return {
    props: { initialApiState: store.getState() },
  };
};

export default StateSitemap;
